import { useMemo } from 'react';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { useRegisterQuickActions } from 'src/components/QuickActions/use-register-quick-actions';
import { gql } from 'src/gql';
import { Address } from 'src/graphql';
import { Conversation } from 'src/graphql/entities/conversation/conversation.types';
import { useClientActions } from './use-client-actions';

const CLIENT_ACTIONS_GROUP = 'Client Actions';

// The hook reads no fields itself; callers spread this fragment so the data
// useClientActions needs is fetched by their view query.
export const UseClientQuickActionsFragment = gql(`
  fragment UseClientQuickActions_Client on Client {
    id
    ...UseClientActions_Client
  }
`);

// eslint-disable-next-line react-refresh/only-export-components
export const useClientQuickActions = ({
  address,
  clientId,
  conversation,
}: {
  clientId: string;
  address?: Partial<Address>;
  conversation?: Conversation;
}) => {
  const { updateClient, copyClientId, copyClientUrl, copyTOS, mergeClients } =
    useClientActions({
      clientId,
      address,
      conversation,
    });

  useRegisterQuickActions(
    useMemo(
      () =>
        [
          { ...updateClient, icon: 'person_edit' },
          mergeClients,
          copyClientId,
          copyClientUrl,
          copyTOS,
        ]
          .filter((option) => ('isAllowed' in option ? option.isAllowed : true))
          .map((action) => ({
            id: action.label,
            icon: <DynamicIcon name={action.icon} />,
            title: action.label,
            group: CLIENT_ACTIONS_GROUP,
            handler: action.handler,
          })),
      [updateClient, mergeClients, copyClientId, copyClientUrl, copyTOS],
    ),
  );
};
